import React, { useRef, useState, useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { TbLockPassword, TbGridDots, TbTrash } from "react-icons/tb";
import Step1NameEventType from "./StepOneEvent";
import Step2SelectCameras from "./SteptwoEvent";
import Step3SetTime from "./StepThreeEvent";
import Step4Notifications from "./StepFourEvent";
import Slider from "react-slick";
import { CreateNewEvent } from "../../../api/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Stp2Event from "./StepTwoSeat";
import { PulseLoader } from "react-spinners";
import ConfirmationPopup from "./Confirmationpopup";
import { useSelector } from "react-redux";

export default function CreateEventWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetAll, keepCameras } = location.state || {};
  const [currentStep, setCurrentStep] = useState(1);
  const camera = JSON.parse(localStorage.getItem("Camera_ids"));
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  console.log("camera", camera);
  const [formData, setFormData] = useState(() => {
    const keepCameras = location.state?.keepCameras || [];
    return {
      event_name: "",
      event_type_id: "",
      camera_ids: keepCameras || [],
      polygon_data: [],
      schedule_days: [],
      schedule_start_time: "",
      schedule_end_time: "",
      notification_data: [],
      event_data: [],
      user_id,
      organization_id,
    };
  });
  console.log("formData", formData);
  const [drawPoints, setDrawPoints] = useState({});
  const [drawMode, setDrawMode] = useState("");
  const [polygonName, setPolygonName] = useState("");
  const [draggingPolygon, setDraggingPolygon] = useState(null);
  const [loading, setLoading] = useState(false);
  // === New line draw states ===
  const [lineData, setLineData] = useState({});
  const [isDrawingLine, setIsDrawingLine] = useState(false);
  const [draggingPoint, setDraggingPoint] = useState(null);
  const [selectedShape, setSelectedShape] = useState(null);
  const [show, setShow] = useState(false);

  // { cameraId, shapeName, shapeType }

  const canvasRefs = useRef({});

  useEffect(() => {
    if (location.state?.reset) {
      setFormData((prev) => ({
        event_name: "",
        event_type_id: "",
        camera_ids: keepCameras || [],
        polygon_data: [],
        schedule_days: [],
        schedule_start_time: "",
        schedule_end_time: "",
        notification_data: [],
        event_data: [],
      }));
    }

    if (camera) {
      let cameraData = [
        {
          camera_id: camera?._id,
          rtsp_url: camera?.rtsp_url,
        },
      ];
      setFormData((prev) => ({
        event_name: "",
        event_type_id: "",
        camera_ids: cameraData || [],
        polygon_data: [],
        schedule_days: [],
        schedule_start_time: "",
        schedule_end_time: "",
        notification_data: [],
        event_data: [],
      }));
    }
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: (dots) => <ul style={{ margin: "0px" }}>{dots}</ul>,
    customPaging: (i) => <>{i + 1}</>,
  };

  const isMultiPolygonMode = formData?.usecase_name === "seat-monitoring";

  const stepsContent = [
    <Step1NameEventType formData={formData} setFormData={setFormData} />,
    isMultiPolygonMode ? (
      <Stp2Event
        formData={formData}
        setFormData={setFormData}
        drawMode={drawMode}
        setDrawMode={setDrawMode}
        polygonName={polygonName}
        setPolygonName={setPolygonName}
      />
    ) : (
      <Step2SelectCameras
        formData={formData}
        setFormData={setFormData}
        drawMode={drawMode}
        setDrawMode={setDrawMode}
        polygonName={polygonName}
        setPolygonName={setPolygonName}
      />
    ),
    <Step3SetTime formData={formData} setFormData={setFormData} />,
    <Step4Notifications formData={formData} setFormData={setFormData} />,
  ];

  const isPointInPolygon = (point, polygon) => {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].x,
        yi = polygon[i].y;
      const xj = polygon[j].x,
        yj = polygon[j].y;
      const intersect =
        yi > point.y !== yj > point.y &&
        point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  };

  const drawOnCanvas = (cameraId) => {
    const canvas = canvasRefs.current[cameraId];
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // === Draw saved line ===
    const line = lineData[cameraId];
    if (line?.points?.length === 2) {
      ctx.beginPath();
      ctx.moveTo(line.points[0].x, line.points[0].y);
      ctx.lineTo(line.points[1].x, line.points[1].y);
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.stroke();

      line.points.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = "red";
        ctx.fill();
      });
    }

    // === Draw saved polygons ===
    const savedZones = formData.polygon_data.filter(
      (z) => z.camera_id === cameraId
    );
    savedZones.forEach((zone) => {
      ctx.beginPath();
      zone.points.forEach((p, i) =>
        i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y)
      );
      ctx.closePath();
      ctx.strokeStyle = "blue";
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.fillStyle = "rgba(0, 0, 255, 0.1)";
      ctx.fill();

      if (zone.name) {
        ctx.fillStyle = "white";
        ctx.font = "bold 20px Arial";
        ctx.shadowColor = "black";
        ctx.shadowBlur = 4;
        ctx.fillText(zone.name, zone.points[0].x + 10, zone.points[0].y - 10);
      }

      zone.points.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, Math.PI * 2);
        ctx.fillStyle = "blue";
        ctx.fill();
      });
    });

    // === Draw temp polygon points ===
    const tempPoints = drawPoints[cameraId] || [];
    if (tempPoints.length) {
      ctx.beginPath();
      tempPoints.forEach((p, i) =>
        i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y)
      );
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
      ctx.stroke();

      tempPoints.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, Math.PI * 2);
        ctx.fillStyle = "red";
        ctx.fill();
      });

      if (polygonName) {
        ctx.fillStyle = "red";
        ctx.font = "14px Arial";
        ctx.fillText(polygonName, tempPoints[0].x + 5, tempPoints[0].y - 5);
      }
    }
  };

  const saveZone = (cameraId, points) => {
    const newPolygon = {
      camera_id: cameraId,
      name: polygonName || `Polygon ${formData.polygon_data.length + 1}`,
      shape_type: "polygon",
      points: points.map((p) => ({
        x: Math.floor(p.x),
        y: Math.floor(p.y),
      })),
    };
    setFormData((prev) => ({
      ...prev,
      polygon_data: isMultiPolygonMode
        ? [...prev.polygon_data, newPolygon]
        : [
            ...prev.polygon_data.filter((z) => z.camera_id !== cameraId),
            newPolygon,
          ],
    }));
    setDrawPoints((prev) => ({ ...prev, [cameraId]: [] }));
    setPolygonName("");
  };

  useEffect(() => {
    setPolygonName(""); // Reset when switching to a different camera
  }, [formData.camera_ids]);

  const saveLine = (cameraId, points) => {
    if (points.length !== 2) return;
    const newLine = {
      camera_id: cameraId,
      shape_type: "line",
      restricted_side: formData.restricted_side || "",
      points: points.map((p) => ({
        x: Math.floor(p.x),
        y: Math.floor(p.y),
      })),
    };
    setFormData((prev) => ({
      ...prev,
      polygon_data: [
        ...prev.polygon_data.filter(
          (z) => !(z.camera_id === cameraId && z.shape_type === "line")
        ),
        newLine,
      ],
    }));
  };
  const handleMouseDown = (e, cameraId) => {
    const canvas = canvasRefs.current[cameraId];
    const rect = canvas.getBoundingClientRect();
    const clickPoint = { x: e.clientX - rect.left, y: e.clientY - rect.top };

    // === SHAPE SELECTION FOR DELETE ===
    // Check polygons
    const clickedPolygonForDelete = formData.polygon_data
      .filter((z) => z.camera_id === cameraId && z.shape_type === "polygon")
      .find((z) => isPointInPolygon(clickPoint, z.points));

    if (clickedPolygonForDelete) {
      setSelectedShape({
        cameraId,
        shapeName: clickedPolygonForDelete.name,
        shapeType: "polygon",
      });
    }

    // Check lines
    const clickedLineForDelete = formData.polygon_data
      .filter((z) => z.camera_id === cameraId && z.shape_type === "line")
      .find((line) => {
        if (!line.points || line.points.length < 2) return false;
        const [p1, p2] = line.points;
        const dist =
          Math.abs(
            (p2.y - p1.y) * clickPoint.x -
              (p2.x - p1.x) * clickPoint.y +
              p2.x * p1.y -
              p2.y * p1.x
          ) / Math.sqrt((p2.y - p1.y) ** 2 + (p2.x - p1.x) ** 2);
        return dist < 6; // 6px tolerance
      });

    if (clickedLineForDelete) {
      setSelectedShape({
        cameraId,
        shapeName: clickedLineForDelete.name || "Line",
        shapeType: "line",
      });
    }

    // === LINE MODE ===
    if (drawMode === "line") {
      const line = lineData[cameraId];
      const dist = (a, b) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
      if (line?.points?.length === 2) {
        if (dist(clickPoint, line.points[0]) < 10) {
          setDraggingPoint({ cameraId, index: 0 });
          return;
        } else if (dist(clickPoint, line.points[1]) < 10) {
          setDraggingPoint({ cameraId, index: 1 });
          return;
        }
      }
      setLineData((prev) => ({
        ...prev,
        [cameraId]: { points: [clickPoint] },
      }));
      setIsDrawingLine(true);
      return;
    }

    // === POLYGON DRAG ===
    const clickedPolygon = formData.polygon_data
      .filter((z) => z.camera_id === cameraId)
      .find((z) => isPointInPolygon(clickPoint, z.points));
    if (clickedPolygon) {
      setDraggingPolygon({
        cameraId,
        polygonName: clickedPolygon.name,
        offset: clickPoint,
      });
      return;
    }

    // === POLYGON DRAW ===
    if (!drawMode) return;
    setDrawPoints((prev) => {
      const updated = [...(prev[cameraId] || []), clickPoint];
      if (updated.length === 5) {
        saveZone(cameraId, updated);
        return { ...prev, [cameraId]: [] };
      }
      return { ...prev, [cameraId]: updated };
    });
  };

  const handleMouseMove = (e, cameraId) => {
    const canvas = canvasRefs.current[cameraId];
    const rect = canvas.getBoundingClientRect();
    const movePoint = { x: e.clientX - rect.left, y: e.clientY - rect.top };

    // === LINE MODE ===
    if (drawMode === "line") {
      if (draggingPoint) {
        setLineData((prev) => {
          const updated = { ...prev };
          updated[cameraId].points[draggingPoint.index] = movePoint;

          // Save to formData immediately
          if (updated[cameraId].points.length === 2) {
            setFormData((prevForm) => ({
              ...prevForm,
              polygon_data: [
                ...prevForm.polygon_data.filter(
                  (z) => !(z.camera_id === cameraId && z.shape_type === "line")
                ),
                {
                  camera_id: cameraId,
                  shape_type: "line",
                  restricted_side: prevForm.restricted_side || "",
                  points: updated[cameraId].points,
                },
              ],
            }));
          }
          return updated;
        });
        return;
      }

      if (isDrawingLine) {
        setLineData((prev) => {
          const updated = { ...prev };
          updated[cameraId].points[1] = movePoint;

          // Save to formData immediately
          if (updated[cameraId].points.length === 2) {
            setFormData((prevForm) => ({
              ...prevForm,
              polygon_data: [
                ...prevForm.polygon_data.filter(
                  (z) => !(z.camera_id === cameraId && z.shape_type === "line")
                ),
                {
                  camera_id: cameraId,
                  shape_type: "line",
                  restricted_side: prevForm.restricted_side || "",
                  points: updated[cameraId].points,
                },
              ],
            }));
          }
          return updated;
        });
      }
      return;
    }

    // === POLYGON DRAG ===
    if (draggingPolygon) {
      const { polygonName } = draggingPolygon;
      const updatedPolygons = [...formData.polygon_data];
      const polyIndex = updatedPolygons.findIndex(
        (p) => p.camera_id === cameraId && p.name === polygonName
      );
      if (polyIndex !== -1) {
        const dx = movePoint.x - draggingPolygon.offset.x;
        const dy = movePoint.y - draggingPolygon.offset.y;
        updatedPolygons[polyIndex].points = updatedPolygons[
          polyIndex
        ].points.map((p) => ({
          x: p.x + dx,
          y: p.y + dy,
        }));
        setFormData((prev) => ({ ...prev, polygon_data: updatedPolygons }));
        setDraggingPolygon({ cameraId, polygonName, offset: movePoint });
      }
    }
  };

  const handleMouseUp = () => {
    if (drawMode === "line" && !draggingPoint && !isDrawingLine) {
      Object.entries(lineData).forEach(([camId, line]) => {
        if (line?.points?.length === 2) {
          saveLine(camId, line.points);
        }
      });
    } else if (drawMode === "line" && isDrawingLine) {
      // If they just finished placing the second point
      Object.entries(lineData).forEach(([camId, line]) => {
        if (line?.points?.length === 2) {
          saveLine(camId, line.points);
        }
      });
    }
    setDraggingPolygon(null);
    setDraggingPoint(null);
    setIsDrawingLine(false);
  };

  useEffect(() => {
    formData.camera_ids.forEach((cam) => drawOnCanvas(cam.camera_id));
  }, [formData.polygon_data, drawPoints, polygonName, lineData]);

  const handleFinish = async () => {
    setLoading(true);

    try {
      const data = await CreateNewEvent(formData);
      if (data) {
        // toast.success("Event is created successfully!!!");
        console.log("11");
        setLoading(false);
        setShow(true);
        localStorage.remove("Camera_ids");
        // navigate("/usecase-events");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteShape = () => {
    if (!selectedShape) return;

    setFormData((prev) => ({
      ...prev,
      polygon_data: prev.polygon_data.filter((shape) => {
        if (selectedShape.shapeType === "line") {
          return !(
            shape.camera_id === selectedShape.cameraId &&
            shape.shape_type === "line"
          );
        }
        return !(
          shape.camera_id === selectedShape.cameraId &&
          shape.name === selectedShape.shapeName &&
          shape.shape_type === selectedShape.shapeType
        );
      }),
    }));

    // 🔹 Clear the lineData too
    if (selectedShape.shapeType === "line") {
      setLineData((prev) => {
        const updated = { ...prev };
        delete updated[selectedShape.cameraId];
        return updated;
      });
    }

    setSelectedShape(null);
  };

  const handleClose = async () => {
    setShow(false);
    navigate("/usecase-events");
  };

  // Redraw on step change
  useEffect(() => {
    if (currentStep === 2) {
      formData.camera_ids.forEach((cam) => {
        const canvas = canvasRefs.current[cam.camera_id];
        const img = document.querySelector(`#cam-img-${cam.camera_id}`);
        if (canvas && img && img.complete) {
          canvas.width = 960;
          canvas.height = 540;
          drawOnCanvas(cam.camera_id);
        }
      });
    }
  }, [currentStep, formData.camera_ids]);

  return (
    <div className="p-5">
      <div className="border bg-white p-2 rounded-3 shadow creatNewEvent">
        <div className="eventStrip rounded-3">
          <h3>Create New Event</h3>
        </div>

        <div className="px-5">
          <div className="row">
            <div className="col-lg-12">
              {/* Steps UI */}
              <ul className="eventSteps">
                {[1, 2, 3, 4].map((step) => {
                  const status =
                    currentStep > step
                      ? "completed"
                      : currentStep === step
                      ? "inProgress"
                      : "";
                  const icons = [
                    <TbLockPassword />,
                    <TbGridDots />,
                    <TbGridDots />,
                    <TbGridDots />,
                  ];
                  const titles = [
                    "Name and Event type",
                    "Set Cameras",
                    "Set Time",
                    "Communication",
                  ];
                  const statusLabel =
                    currentStep > step
                      ? "Completed"
                      : currentStep === step
                      ? "In Progress"
                      : "Pending";
                  return (
                    <li key={step} className={status}>
                      <span className="stepIcon">{icons[step - 1]}</span>
                      <p className="steps">Step {step}</p>
                      <h3>{titles[step - 1]}</h3>
                      <span className="process">{statusLabel}</span>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* LEFT */}
            {/* <div className="col-lg-7 pt-5"></div> */}

            {/* RIGHT Camera Feed */}
            {/* <div className="col-lg-5"></div> */}
          </div>
          <div className="steperFields pt-5">
            <div className="stepsLeftSide">{stepsContent[currentStep - 1]}</div>
            <div className="stepsRightSide">
              <div className="sliderCst pb-3">
                {currentStep === 2 && formData.camera_ids.length > 0 ? (
                  <>
                    <Slider {...settings}>
                      {formData.camera_ids.map((cam) => (
                        <div
                          key={cam.camera_id}
                          style={{
                            position: "relative",
                            width: "960px",
                            height: "540px",
                            overflow: "hidden",
                            borderRadius: "8px",
                            background: "#000",
                          }}
                        >
                          <img
                            src={`https://visionemptrack.greymatterz.com/stream2/stream2/${
                              cam?.camera_id
                            }?t=${Date.now()}`}
                            alt="Camera Feed"
                            width={960}
                            height={540}
                            onLoad={() => {
                              const canvas = canvasRefs.current[cam.camera_id];
                              if (canvas) {
                                canvas.width = 960;
                                canvas.height = 540;
                                drawOnCanvas(cam.camera_id);
                              }
                            }}
                            onError={() =>
                              console.warn(
                                `Failed to load camera ${cam.camera_id}`
                              )
                            }
                          />

                          <canvas
                            ref={(el) =>
                              el && (canvasRefs.current[cam.camera_id] = el)
                            }
                            width={960}
                            height={540}
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              cursor: drawMode ? "crosshair" : "move",
                              pointerEvents: "auto",
                            }}
                            onMouseDown={(e) =>
                              handleMouseDown(e, cam.camera_id)
                            }
                            onMouseMove={(e) =>
                              handleMouseMove(e, cam.camera_id)
                            }
                            onMouseUp={handleMouseUp}
                          />
                        </div>
                      ))}
                    </Slider>
                    {selectedShape && (
                      <button
                        className="btn btn-danger d-flex align-items-center gap-2"
                        onClick={handleDeleteShape}
                      >
                        <TbTrash /> Delete Selected Shape
                      </button>
                    )}
                  </>
                ) : (
                  <div className="text-center">
                    <img
                      className="img-fluid"
                      src="../images/creat-event-ai.png"
                      alt="Event Placeholder"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="d-flex justify-content-end align-items-center gap-4 p-4 mt-4 border-top">
          {currentStep > 1 && (
            <button
              className="transParent3"
              onClick={() => setCurrentStep((p) => p - 1)}
            >
              Back
            </button>
          )}
          {currentStep < 4 ? (
            <button
              className="mainBlue3"
              onClick={() => setCurrentStep((p) => p + 1)}
            >
              Next
            </button>
          ) : loading ? (
            <button className="mainBlue3">
              <PulseLoader color="#fff" />
            </button>
          ) : (
            <button className="mainBlue3" onClick={handleFinish}>
              Finish
            </button>
          )}
        </div>
      </div>
      {show && (
        <ConfirmationPopup
          formData={formData}
          onClose={handleClose}
          onAddMore={() => {
            setCurrentStep(1);

            navigate("/create-new-event", {
              state: {
                keepCameras: formData.camera_ids,
                reset: true,
              },
            });
            setFormData((prev) => ({
              event_name: "",
              event_type_id: "",
              camera_ids: keepCameras || [],
              polygon_data: [],
              schedule_days: [],
              schedule_start_time: "",
              schedule_end_time: "",
              notification_data: [],
              event_data: [],
            }));
            setShow(false);
          }}
        />
      )}
    </div>
  );
}
